export default __webpack_public_path__ + "static/media/graphsPreviewDark.fc9474b6.png";